import React, {useState} from "react";
import {useData} from "vike-react/useData";
import {ApiVideoCategory, ApiVideosData} from "#/src/definitions/ApiDefinitions";
import AppConstants from "#/src/utils/app-constants";
import {composeHeaders} from "#/src/utils/api-request-utils";
import {usePageContext} from "vike-react/usePageContext";
import {AppPageContext, DataWrapped} from "#/src/definitions/AppDefinitions";
import {SweetAlert2} from "#/src/components/SweetAlert2";
import {toast} from "react-toastify";
import SearchSvg from "#/src/components/SearchSvg";

interface Props {
  category: "MAIN" | "AWAITING",
  setCategory: (type: "MAIN" | "AWAITING") => void
  onQuery: (query: string) => void
}

export function Header({category, setCategory, onQuery}: Props) {
  const pageContext = usePageContext() as AppPageContext;
  const {data: videosData} = useData() as DataWrapped<ApiVideosData>;
  const [newVideo, setNewVideo] = useState<boolean>(false);

  async function onVideoResult(result: boolean) {
    const url = (document.getElementById("new-video-url") as HTMLInputElement).value;
    const categoryId = (document.getElementById("new-video-category") as HTMLSelectElement).value;
    setNewVideo(false);
    if (result) {
      const response = await fetch(`${AppConstants.API_ROUTE}/videos`, {
        method: "POST",
        headers: composeHeaders(pageContext),
        body: JSON.stringify({url, categoryId})
      });
      if (response.ok) {
        toast("Dodano filmik do poczekalni, jest on na razie w trakcie moderacji.");
        setTimeout(() => window.location.reload(), 1500);
      } else {
        const errorResponse = await response.json() as any;
        if (errorResponse && errorResponse.errors) {
          errorResponse.errors.forEach(err => toast(err));
        }
      }
    }
  }

  function onEnterCheck(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === "Enter") {
      onQuery((document.getElementById("videoSearch") as HTMLInputElement).value);
    }
  }

  return <header className="video-header">
    <div className="container-xxl">
      <div className="title-between flex-wrap pt-5">
        <h2 className="basic-headline">
          Filmy
        </h2>
        {pageContext.user.loggedIn && <button type="button" className="btn btn-primary" onClick={() => setNewVideo(true)}>
          Dodaj swój film
        </button>}
        <SweetAlert2
          show={newVideo}
          onAction={onVideoResult}
          onClose={() => setNewVideo(false)}
          padding={"2em"}
          confirmButtonText={"Dodaj filmik"}
          customClass={{
            confirmButton: "swal-confirm-video"
          }}
          width={"50em"}
          title={<div className={"mb-4"}>Dodaj nowy filmik</div>}
        >
          <div className={"row"}>
            <div className={"col-lg-6 col-12"}>
              <div className={"mb-3"}>URL do filmiku</div>
              <input className={"form-control"} type={"text"} id={"new-video-url"} placeholder={"Podaj link"}/>
            </div>
            <div className={"col-lg-6 col-12 mt-lg-0 mt-3"}>
              <div className={"mb-3"}>Kategoria filmiku</div>
              <select className={"form-control"} id={"new-video-category"}>
                {videosData.categories.map((category: ApiVideoCategory) => {
                  return <option key={category.id} value={category.id}>{category.name}</option>
                })}
              </select>
            </div>
          </div>
        </SweetAlert2>
      </div>
      <ul className="video-nav-header nav-header">
        <li className={`nav-header-item ${category == "MAIN" ? "active" : ""}`} onClick={() => setCategory("MAIN")}>
          <a href="#" className={`nav-header-link ${category == "MAIN" ? "active" : ""}`}>Główna</a>
        </li>
        <li className={`nav-header-item ${category == "AWAITING" ? "active" : ""}`} onClick={() => setCategory("AWAITING")}>
          <a href="#" className={`nav-header-link ${category == "AWAITING" ? "active" : ""}`}>Poczekalnia</a>
        </li>
      </ul>
      <div className="video-flex-input flex-input">
        <input id={"videoSearch"} type="text" className="form-search" placeholder="Wyszukaj" aria-label="Wyszukaj" aria-describedby="button-addon2"
               onKeyDown={onEnterCheck} autoComplete={"off"}/>
        <button className="btn-form" type="button" id="button-addon2" onClick={() => onQuery((document.getElementById("videoSearch") as HTMLInputElement).value)}>
          <SearchSvg/>
        </button>
      </div>
    </div>
  </header>
}